import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminApi } from '../api/client';
import GumballIcon from '../components/GumballIcon';
import './css/admin-dashboard.css';

const CARDS = [
  { key: 'announcements', label: 'Announcements', icon: 'megaphone', path: '/admin/announcements' },
  { key: 'roadmap', label: 'Roadmap Items', icon: 'roadmap', path: '/admin/roadmap' },
  { key: 'homepage', label: 'Homepage Sections', icon: 'home', path: '/admin/homepage' },
  { key: 'socials', label: 'Social Links', icon: 'link', path: '/admin/socials' },
  { key: 'media', label: 'Media Uploads', icon: 'media', path: '/admin/media' },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    adminApi.getStats()
      .then(setStats)
      .catch((e) => setError(e.message));
  }, []);

  return (
    <div className="admin-page admin-page--dashboard">
      <header className="admin-page-header">
        <h1>Dashboard</h1>
        <p>Manage Gumball Buddies site content from one place.</p>
      </header>

      {error && <div className="admin-alert admin-alert-error">{error}</div>}

      <div className="admin-stats-grid">
        {CARDS.map((card) => {
          const data = stats?.[card.key];
          return (
            <Link key={card.key} to={card.path} className="admin-stat-card">
              <span className="admin-stat-icon">
                <GumballIcon name={card.icon} size={28} />
              </span>
              <div>
                <h3>{card.label}</h3>
                {data ? (
                  <p className="admin-stat-count">
                    {data.total} total
                    {data.published !== undefined && (
                      <span className="admin-stat-published"> · {data.published} published</span>
                    )}
                  </p>
                ) : (
                  <p className="admin-stat-count">Loading...</p>
                )}
              </div>
            </Link>
          );
        })}
      </div>

      <section className="admin-card admin-quick-tips">
        <h2>Quick Tips</h2>
        <ul>
          <li>Set content to <strong>Published</strong> to show it on the live site.</li>
          <li>Use <strong>Sort Order</strong> to control display order (lower numbers appear first).</li>
          <li>Upload images in Media, then paste the URL into roadmap or homepage fields.</li>
          <li>The public site falls back to defaults if the API is unavailable.</li>
        </ul>
      </section>
    </div>
  );
}
